export enum OrderFilterOptions {
  WITH_PARTNER_SCAN = 'Partner Scan',
  WITHOUT_PARTNER_SCAN = 'No partner scan',
  WITH_HUB_SCAN = 'Hub scan',
  WITHOUT_HUB_SCAN = 'No Hub scan',
  WITH_TEMP_CONTROL = 'Show Only Temperature Controlled Orders',
  WITH_ID_CHECK = 'Id check',
  WITHOUT_TEMP_CONTROL = 'Hide Temperature Controlled Orders',
  XXL = 'Oversized orders',
  RESCHEDULED = 'Rescheduled orders',
}
